import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import styled from 'styled-components';
import { getMarketProducts } from 'ducks/products';
import store from 'ducks/configureStore';
import { useCore } from 'contexts/core';
import { useIntl } from 'react-intl';

const Wrapper = styled.div`
  padding: 1rem 0 0 0;
`;

function OnlyOneColorMessage() {
  const { formatMessage } = useIntl();
  const coreApi = useCore();

  const getColorOfCurrentlySelectedProduct = () => {
    const selectedEntity = coreApi.entities.findSelectedEntity();
    if (!selectedEntity) return undefined;

    const id = coreApi.entities.getProductRef(selectedEntity);
    const products = getMarketProducts(store.getState());
    const selectedProduct = products.find(p => p.coreProductId === id);
    if (!selectedProduct) return undefined;

    return selectedProduct?.designText;
  };

  const onlyOneColorMessage = {
    message: 'storageone.frameSizeAvailableInOnlyOneColourMessage',
    params: {
      colour: getColorOfCurrentlySelectedProduct()
    }
  };

  return (
    <Wrapper>
      <SkapaInlineMessage
        body={formatMessage({ id: onlyOneColorMessage.message }, onlyOneColorMessage.params)}
        variant={InlineMessageVariantEnum.INFORMATIVE}
        ssrIcon={InformationCircle}
        subtle
      />
    </Wrapper>
  );
}

export default OnlyOneColorMessage;
